import { RSB_ONLINE_URL } from '../constants';

export const footer: FooterSetup = {
    buttonLabel: 'Give us feedback',
    buttonLink: 'https://kromatic.com/feedback?app=experiment-calculator',
    links: [
        {
            label: 'The Real Startup Book — the framework behind this tool',
            href: RSB_ONLINE_URL,
        },
        {
            label: 'Privacy Policy',
            href: 'https://kromatic.com/privacy-policy',
        },
        {
            label: 'Terms of Service',
            href: 'https://kromatic.com/terms-of-service',
        },
    ],
    poweredBy: true,
};
